export default __webpack_public_path__ + "static/media/04.aeae7deb.png";